export enum ProfileUserRouteMessageCode {
  CannotUpdateUserDetails = 'data.errorMessages.cannotUpdateUserDetails',
}
